<!-- /src/components/common/Search/ActiveQueries.vue -->
<template>
  <div
    v-if="activeQueries.length > 0"
    class="active-queries button__group">
    Filter Results: 
    <button
      v-for="(query, key) in activeQueries"
      :key="key"
      class="button button--withIcon button--sm button--accent"
      @click="removeFilterItem(query.originalQuery)"
    >
    <span class="fas fa-times-circle"></span> {{ query.buttonText }}
    </button>
  </div>
</template>

<script>
import searchMixin from '@/mixins/searchMixin'

export default {
  name: 'activeQueries',
  data() {
    return {
    }
  },

  computed: {
  },

  filters: {
  },

  watch: {
    $route() {
      this.getActiveQueries()
        .then(res => {
          this.activeQueries = res
        })
    }
  },


  methods: {
  //   removeFilterItem(queryItem) {
  //     let { query, name } = this.$route
  //     query = _omit(query, _keys(queryItem))
  //     this.$router.push({
  //       name,
  //       query,
  //     })
  //   },

  //   toggleFilters() {
  //     this.showFilters = !this.showFilters
  //   },

  //   initialCaps(string) {
  //     return string.split(' ').map(word => {
  //       return word[0].toUpperCase() + word.substr(1)
  //     }).join(' ')
  //   }
  },

  beforeMount() {
    this.getActiveQueries()
      .then(res => {
        this.activeQueries = res
      })
  },

  mixins: [searchMixin],

  // components: {
  // },
}
</script>

<style scoped>
.card-grid-header {
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }

  &__actions {
    font-size: 0.7em;
    justify-self: start;
    grid-template-columns: 1fr;
    display: grid;
    @media(--tablet) {
      display: flex;
      /* grid */
    }
  }
}

.form__control {
  margin: 0;
}

</style>
